export const buildWhatsAppUrl = (text: string) => {
    const normalizedText = text.normalize('NFC');
    return `https://wa.me/?text=${encodeURIComponent(normalizedText)}`;
};
